// @flow

import { observer } from "mobx-react";
import React from "react";

import AppearanceStore from "app/stores/AppearanceStore";
import TimelineItemStore from "app/stores/TimelineItemStore";
import VideoStore from "app/stores/VideoStore";
import VideoPlayerStore from "app/stores/VideoPlayerStore";

import TimelineBars from "app/components/TimelineBars/TimelineBars";

@observer
export default class TimelineBarsContainer extends React.Component<*> {
    render() {
        if (VideoStore.video.isPublished && AppearanceStore.hiddenThumbnails)
            return null;

        const item: any = TimelineItemStore.selectedItem;

        return (
            <TimelineBars
                video={VideoStore.video}
                progress={VideoPlayerStore.progress}
                items={TimelineItemStore.items}
                selectedItem={item}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/containers/TimelineBarsContainer.js